export type ParsedTargetSearchInput = {
  deviceSearch: string;
  interfaceFilter: string;
};

export const parseTargetSearchInput = (
  input: string,
): ParsedTargetSearchInput => {
  const slashIndex = input.indexOf('/');
  if (slashIndex === -1) {
    return { deviceSearch: input.trim(), interfaceFilter: '' };
  }

  return {
    deviceSearch: input.slice(0, slashIndex).trim(),
    interfaceFilter: input.slice(slashIndex + 1).trim(),
  };
};

export const isTargetSearchReady = ({
  deviceSearch,
  interfaceFilter,
}: ParsedTargetSearchInput): boolean =>
  deviceSearch.length > 0 || interfaceFilter.length > 0;
